export default __webpack_public_path__ + "static/logo3-f6b0b5b540a67634a3e8490b50e2b6d9.png";